import Navigation from "../../header";
import { Container } from "@mui/material";
import { PowerBIEmbed } from 'powerbi-client-react';
import { IEmbedConfiguration, models } from 'powerbi-client';
import PermissionGate from "../../permissionGate";
import { useUserContext } from "../../../contexts/userContext";

const CostCreditReport = () => {
	var userContext = useUserContext();

	return (
		<>
			<Navigation></Navigation>
			<Container maxWidth="lg" className="route-container">
				<PermissionGate permission={userContext?.permissions?.canViewReportCostCredit}>
					<h1 className="report-header">Cost Credit Report</h1>
					{/* <iframe title="HWIOnline_CostCredit_DEV" width="1140" height="700" src="https://app.powerbi.com/reportEmbed?reportId=bcd961a9-f721-40db-aad8-04c494e4c3cb&autoAuth=true&ctid=3d903043-2b47-4eb6-ba60-a27fe7950ef2" frameBorder="1"></iframe> */}
					<embed width="1200" height="800" src="https://app.powerbi.com/rdlEmbed?reportId=c0d088b9-f278-4e34-a9bb-a46c464b44a7&autoAuth=true&ctid=3d903043-2b47-4eb6-ba60-a27fe7950ef2&experience=power-bi"></embed>
				</PermissionGate>
			</Container>
		</>
	);
};

export default CostCreditReport;